import ProjectCard from "../../components/Projects";

const ProjectPage = () => {
  return (
    <div className="container">
      <ProjectCard />
    </div>
  );
};

export default ProjectPage;
